import styled from "styled-components";

const mobile = "@media (max-width: 768px)";

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #E71037;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    opacity: 0.7;
  }
`;

export const InvoiceTableWrapper = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  margin-top: 24px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);

  min-width: 0; 
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  background: #d32f2f;
  padding: 16px 20px;

  ${mobile} {
    padding: 10px 12px; 
  }
`;

export const HeaderCell = styled.div`
  flex: ${({ flex }) => flex || 1};
  min-width: 0;

  display: flex;
  align-items: center;
  justify-content: ${({ align }) =>
    align === "right" ? "flex-end" : "flex-start"};

  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;

  ${mobile} {
    font-size: 11px; 
  }
`;

export const TableBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const TableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 20px;

  background: ${({ odd }) => (odd ? "#fafafa" : "#ffffff")};
  border-bottom: 1px solid #ececec;

  min-width: 0;

  &:last-child {
    border-bottom: none;
  }

  ${mobile} {
    padding: 10px 12px; 
  }
`;

export const TableCell = styled.div`
  flex: ${({ flex, align }) =>
    align === "right" ? "0 0 auto" : flex || 1};

  min-width: ${({ align }) => (align === "right" ? "80px" : "0")};

  display: flex;
  align-items: center;

  justify-content: ${({ align }) =>
    align === "right" ? "flex-end" : "flex-start"};

  overflow: hidden;

  ${mobile} {
    padding: 0 4px;
  }
`;

export const DateBlock = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const DateMain = styled.span`
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;

  ${mobile} {
    font-size: 12px;
  }
`;

export const DateSub = styled.span`
  font-size: 12px;
  color: #666;
  white-space: nowrap;

  ${mobile} {
    font-size: 11px;
  }
`;

export const DescriptionBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 10px;

  ${mobile} {
    width: 26px;
    height: 26px;
    margin-right: 6px;
  }
`;

export const DescriptionContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  width: 100%;
`;

export const EstablishmentName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #111827;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mobile} {
    font-size: 13px;
  }
`;

export const EstablishmentDetail = styled.span`
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  direction: rtl;
  text-align: left;

  ${mobile} {
    font-size: 11px;
  }
`;

export const ValueText = styled.span`
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
  flex-shrink: 0;
  
  ${mobile} {
    font-size: 13px;
  }
`;

export const InvoiceFooter = styled.div`
  width: 100%;
  background: #d32f2f;
  color: #ffffff;
`;

export const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;

  ${mobile} {
    padding: 14px 12px;
  }
`;

export const FooterTopLabel = styled.span`
  font-size: 14px;
  font-weight: 700;

  ${mobile} {
    font-size: 13px;
  }
`;

export const FooterTopValue = styled.span`
  font-size: 20px;
  font-weight: 700;

  ${mobile} {
    font-size: 16px;
  }
`;

export const FooterDivider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.85);
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;

  ${mobile} {
    padding: 14px 12px;
  }
`;

export const FooterInfoItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mobile} {
    align-items: flex-start;
  }
`;

export const FooterInfoLabel = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
`;

export const FooterInfoValue = styled.span`
  margin-top: 6px;
  font-size: 14px;
  font-weight: 700;

  ${mobile} {
    font-size: 13px;
  }
`;